import { trim } from 'lodash';
import { object, string } from 'yup';

import { MindFeedbackType } from '../../../../data/types/api/graphql';

export const schema = object()
  .shape({
    feedback: string()
      .oneOf(Object.values(MindFeedbackType))
      .default(MindFeedbackType.Unknown),
    text: string().transform(trim).optional().default(''),
  })
  .required()
  .noUnknown();
